<ng-container *ngIf="visible">
  <button
    type="button"
    class="doc-pdf-btn doc-pdf-btn--os"
    [class.doc-pdf-btn--ready]="isGenerated"
    [class.doc-pdf-btn--muted]="!isGenerated"
    matTooltip="Ver PDF de la Orden de Servicio"
    aria-label="Ver PDF OS"
    (click)="$event.stopPropagation(); openPdfDialog()"
  >
    <mat-icon class="doc-pdf-btn__icon">picture_as_pdf</mat-icon>
  </button>
</ng-container>
